import { Component, input, signal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faCrown, faStar } from '@fortawesome/pro-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

type SubscriptionPlan = 'annual' | 'quarterly';

@Component({
  selector: 'app-subscription-plans',
  templateUrl: './subscription-plans.component.html',
  styleUrls: ['./subscription-plans.component.scss'],
  imports: [TranslateModule, FontAwesomeModule],
})
export class SubscriptionPlansComponent {
  readonly resubscription = input<boolean>(false);
  readonly disableButtons = input<boolean>(false);
  readonly reference = input<any>();
  readonly isSubscriptionInProgress = signal(false);
  readonly selectedPlan = signal<SubscriptionPlan>('annual');
  readonly faCheck = faCheck;
  readonly faCrown = faCrown;
  readonly faStar = faStar;
  readonly featureKeys = [
    'SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_1',
    'SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_2',
    'SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_3',
    'SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_4',
  ];

  constructor() {}

  selectPlan(plan: SubscriptionPlan): void {
    this.selectedPlan.set(plan);
  }

  subscribeYearly() {
    this.subscribeOnce(() => this.reference().yearlyPayment());
  }

  subscribeMonthly() {
    this.subscribeOnce(() => this.reference().monthlyPayment());
  }

  subscribeQuarterly() {
    this.subscribeOnce(() => this.reference().quarterlyPayment());
  }

  subscribeSelectedPlan(): void {
    if (this.selectedPlan() === 'quarterly') {
      this.subscribeQuarterly();
      return;
    }

    this.subscribeYearly();
  }

  private subscribeOnce(subscribe: () => void): void {
    if (this.disableButtons() || this.isSubscriptionInProgress()) {
      return;
    }

    this.isSubscriptionInProgress.set(true);
    subscribe();
  }
}
